'use client'

import clsx from 'clsx'
import {ReactNode} from 'react'
import s from './style.module.scss'
import {useIsGamePage} from '@app/[lang]/(common-header-footer)/content-wrapper/content-wrapper-client'

type Props = {
  children: ReactNode
  isOpen: boolean
}

const DesktopWideMonitorSidebar = ({children, isOpen}: Props) => {
  const {isGamePage} = useIsGamePage()

  return (
    <>
      {!isGamePage && isOpen && <div className={s.placeholder} />}
      <aside
        className={clsx(s.desktop_open_sidebar_container, isOpen ? s.open : s.closed, {
          // ['!absolute']: isGamePage,
        })}
      >
        {children}
      </aside>
    </>
  )
}

export default DesktopWideMonitorSidebar
